import React, { useEffect, useState } from 'react';

import { useUserManager } from 'Shared/User/Hooks/useUserManager';

interface IProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FunctionComponent<IProtectedRouteProps> = (props: IProtectedRouteProps) => {
  const [show, setShow] = useState<boolean>(false);
  const { signIn, getUser } = useUserManager();

  useEffect(() => {
    getUser().then((user: any) => {
      if (user && !user.expired) {
        setShow(true);
      } else {
        signIn(window.location.href);
      }
    });
  }, []);

  return <>{show && props.children}</>;
};

export default ProtectedRoute;
